import { Component, OnInit } from '@angular/core';
import { ParametreService } from '../services/parametre.service';

@Component({
  selector: 'app-theatre',
  templateUrl: './theatre.component.html',
  styleUrls: ['./theatre.component.css']
})
export class TheatreComponent implements OnInit {

  // Position du curseur en pourcentage (0 = tout en mode "nuit", 100 = tout en mode "jour")
  position = 50;

  photoJour = 'https://images.unsplash.com/photo-1503095396549-807759245b35?w=1000';
  photoNuit = 'https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=1000';

  constructor(private parametreService: ParametreService) { }

  ngOnInit(): void {
    this.parametreService.getParametres().subscribe(data => {
      if (data.photoTheatreJour) this.photoJour = data.photoTheatreJour;
      if (data.photoTheatreNuit) this.photoNuit = data.photoTheatreNuit;
    });
  }

  deplacerCurseur(event: MouseEvent): void {
    const zone = (event.currentTarget as HTMLElement).getBoundingClientRect();
    const pourcentage = ((event.clientX - zone.left) / zone.width) * 100;
    this.position = Math.min(96, Math.max(4, pourcentage));
  }
}
